import type { PositionsTabType } from './types';

export const MARKET_ACCOUNTS_TAB_LABEL = 'Market Accounts';

const UNIFIED_TAB_LABEL_PATTERN = /^Unified(?: \((\d+)\))?$/;

export function getPositionsTabTypeLabel(tabType: PositionsTabType): string {
  if (tabType === 'Unified') {
    return MARKET_ACCOUNTS_TAB_LABEL;
  }

  return tabType;
}

export function normalizePersistedPositionsTabLabel<T extends { tabType: PositionsTabType; label?: string }>(
  tab: T
): T {
  if (tab.tabType !== 'Unified' || tab.label == null) {
    return tab;
  }

  const suffix = UNIFIED_TAB_LABEL_PATTERN.exec(tab.label)?.[1];
  if (suffix == null && tab.label !== 'Unified') {
    return tab;
  }

  return {
    ...tab,
    label: suffix ? `${MARKET_ACCOUNTS_TAB_LABEL} (${suffix})` : MARKET_ACCOUNTS_TAB_LABEL,
  };
}
